var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ObjectManager',{directives:[{name:"show",rawName:"v-show",value:(_vm.functionStatus == '对象管理'),expression:"functionStatus == '对象管理'"}]})
}
var staticRenderFns = []

export { render, staticRenderFns }